import React from 'react';
import { Box, CircularProgress, Alert, Button, Container, Paper, Typography } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useLegalDocuments } from '../hooks/useLegalDocuments';
import { LegalPdfViewer } from '../components/LegalPdfViewer';
import { formatVersion } from '../utils/legalApi';
import { en } from '../translations/en';

export const PrivacyPolicyPage: React.FC = () => {
  const { data, loading, error } = useLegalDocuments();
  const privacyData = data?.privacy ?? null;

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom sx={{ fontFamily: 'Libre Baskerville, serif' }}>
          {en.legal.privacyTitle}
        </Typography>
        {privacyData && (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="subtitle2" color="text.secondary">
              {en.legal.effective.replace('{date}', new Date(privacyData.effectiveDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }))}
              {' \u2014 '}
              {formatVersion(privacyData.version)}
            </Typography>
            <Button
              component="a"
              href={privacyData.presignedUrl}
              download={privacyData.fileName}
              target="_blank"
              rel="noopener noreferrer"
              size="small"
              variant="text"
              startIcon={<FileDownloadIcon />}
              sx={{ textTransform: 'none' }}
            >
              {en.legal.downloadPdf}
            </Button>
          </Box>
        )}
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        )}
        {error && <Alert severity="error">Unable to load document. Please try again.</Alert>}
        {!loading && !error && (
          privacyData ? (
            <LegalPdfViewer url={privacyData.presignedUrl} />
          ) : (
            <Alert severity="info">Legal document not yet available. Please check back later.</Alert>
          )
        )}
      </Paper>
    </Container>
  );
};
